import React from "react";
import { observer } from "mobx-react";

import { useAppStore } from "../../providers/AppStoreProvider";
import { Detail } from "./Detail";
import { Shortcuts } from "./Shortcuts";
import { Timeline } from "./Timeline";
import { Resources } from "./Resources";
import { SupportBanner } from "../../components/SupportBanner/SupportBanner";

import "./Content.scss";

export const Content = observer(({ setCurrentTime }) => {
  const store = useAppStore();

  return (
    <div>
      {store.currentLesson && (
        <>
          <Detail />
          {store.currentLesson?.lesson_type === "video" && (
            <Timeline setCurrentTime={setCurrentTime} />
          )}
          <Shortcuts shortcuts={store.currentLesson.keyboard_shortcuts} />
          <Resources />
        </>
      )}

      <SupportBanner />
    </div>
  );
});
